export const AWS_COGNITO = {
  userPoolId: "eu-central-1_QN063qQbV",
  userPoolClientId: "truc492s1j94qrrdo9n1rmatf",
};
